<template>
  <v-img
    :src="manageImage(src)"
    :lazy-src="manageImage(thumbnail)"
    alt="avatar"
    aspect-ratio="1"
  />
</template>

<script>
export default {
  name: 'lazy-image',
  props: {
    src: String,
    thumbnail: String
  },
  methods: {
    manageImage(src) {
      return src || require('@/assets/default-avatar.svg')
    }
  }
}
</script>
